'use client';
import { Close, Location } from '../ui/Icons';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';

interface LocationInputProps {
  wrapClassName?: string;
  iconClassName?: string;
  inputClassName?: string;
  dropDownMenuClassName?: string;
  onLocationSet?: (e: any) => void;
  inputId?: string;
}
const LocationInput = ({
  wrapClassName,
  iconClassName,
  inputClassName,
  inputId = 'google-place',
}: LocationInputProps) => {
  const t = useTranslations();

  return (
    <div className="relative">
      <div
        className={cn(
          `search-box group relative w-full min-w-[350px] overflow-hidden rounded-full border shadow-[0px_14px_70px_rgba(0,0,0,0.1)] lg:w-[410px]`,
          wrapClassName
        )}
      >
        <input
          type="text"
          id={inputId}
          required
          className={cn(
            `searchPageSearch w-full border-0 bg-white pb-[19px] pl-[40px] pr-[75px] pt-[21px] text-base text-paragraph caret-paragraph outline-0 focus:border-0 focus:ring-0`,
            inputClassName
          )}
          placeholder={t('restaurant_search_placeholder')}
          aria-label={t('restaurant_search_placeholder')}
        />
        <button
          className="close-icon absolute bottom-0 right-12 top-0 z-10 text-primary"
          type="reset"
        >
          <Close className="h-6" />
        </button>
        <div
          className={`${iconClassName} absolute right-[20px] top-[20px] flex h-[24px] w-[24px] items-center justify-center text-neutral-500`}
        >
          <Location />
          {/* <Image
            src="/location.png"
            alt="Loaction Sraerch"
            width={20}
            height={20}
            sizes="100vw"
          /> */}
        </div>
      </div>
    </div>
  );
};

export default LocationInput;
